
const now = new Date();
const weekAgo = (n: number) => {
  const d = new Date(now);
  d.setDate(d.getDate() - n * 7);
  return d.toISOString();
};
const dayAgo = (n: number) => {
  const d = new Date(now);
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

const SYNTH_FUNNEL = [
  { swimlane_uid: "s1", swimlane_name: "WISHLIST",  position: 1, count: 48, conversion: 100.0 },
  { swimlane_uid: "s2", swimlane_name: "APPLIED",   position: 2, count: 34, conversion: 70.8 },
  { swimlane_uid: "s3", swimlane_name: "INTERVIEW", position: 3, count: 12, conversion: 25.0 },
  { swimlane_uid: "s4", swimlane_name: "OFFER",     position: 4, count: 3,  conversion: 6.3  },
  { swimlane_uid: "s5", swimlane_name: "REJECTED",  position: 5, count: 19, conversion: 39.6 },
];

const SYNTH_KPIS_30D = {
  total_jobs: 23,
  total_jobs_delta: 5,
  total_activities: 61,
  total_activities_delta: 14,
  contacts_linked: 9,
  notes_count: 17,
  notes_count_delta: 4,
  pct_completed_activities: 72.1,
  avg_activities_per_job: 2.65,
};

const SYNTH_JOBS_OVER_TIME_30D = [
  { period: dayAgo(28), count: 2 },
  { period: dayAgo(21), count: 4 },
  { period: dayAgo(14), count: 3 },
  { period: dayAgo(7),  count: 8 },
  { period: dayAgo(0),  count: 6 },
];

const SYNTH_ACTIVITIES_BY_TYPE_30D = [
  { type: "phone_screen", period: weekAgo(4), count: 3 },
  { type: "phone_screen", period: weekAgo(3), count: 5 },
  { type: "phone_screen", period: weekAgo(2), count: 4 },
  { type: "phone_screen", period: weekAgo(1), count: 6 },
  { type: "interview",    period: weekAgo(4), count: 1 },
  { type: "interview",    period: weekAgo(3), count: 2 },
  { type: "interview",    period: weekAgo(2), count: 3 },
  { type: "interview",    period: weekAgo(1), count: 4 },
  { type: "follow_up",   period: weekAgo(4), count: 4 },
  { type: "follow_up",   period: weekAgo(3), count: 6 },
  { type: "follow_up",   period: weekAgo(2), count: 8 },
  { type: "follow_up",   period: weekAgo(1), count: 5 },
];

const SYNTH_STALE_JOBS = [
  { uid: "j1", company_name: "Acme Corp",     job_title: "Senior Engineer",   swimlane_name: "APPLIED",   last_updated: dayAgo(22) },
  { uid: "j2", company_name: "GlobalTech",    job_title: "Product Manager",   swimlane_name: "INTERVIEW", last_updated: dayAgo(18) },
  { uid: "j3", company_name: "Startup XYZ",   job_title: "Frontend Developer", swimlane_name: "APPLIED",  last_updated: dayAgo(15) },
];

const SYNTH_UPCOMING = [
  { uid: "a1", title: "Follow-up email",   type: "follow_up",   start_date: dayAgo(-1), company_name: "Acme Corp",  job_title: "Senior Engineer" },
  { uid: "a2", title: "Technical Interview", type: "interview", start_date: dayAgo(-2), company_name: "GlobalTech", job_title: "Product Manager" },
  { uid: "a3", title: "Recruiter call",    type: "phone_screen", start_date: dayAgo(-4), company_name: "NewCo",     job_title: "FullStack Dev" },
];

const buildPeriod = (kpis: typeof SYNTH_KPIS_30D, jobsOverTime: typeof SYNTH_JOBS_OVER_TIME_30D, activitiesByType: typeof SYNTH_ACTIVITIES_BY_TYPE_30D) => ({
  funnel: SYNTH_FUNNEL,
  kpis,
  jobs_over_time: jobsOverTime,
  activities_by_type: activitiesByType,
});

export const SYNTHETIC_ANALYTICS_DATA = {
  computed_at: new Date(Date.now() - 3 * 60 * 1000).toISOString(),
  periods: {
    "7d": buildPeriod(
      { ...SYNTH_KPIS_30D, total_jobs: 8, total_jobs_delta: 2, total_activities: 21, total_activities_delta: 5, notes_count: 6, notes_count_delta: 1 },
      SYNTH_JOBS_OVER_TIME_30D.slice(-2),
      SYNTH_ACTIVITIES_BY_TYPE_30D.filter((_, i) => i % 4 === 3)
    ),
    "30d": buildPeriod(SYNTH_KPIS_30D, SYNTH_JOBS_OVER_TIME_30D, SYNTH_ACTIVITIES_BY_TYPE_30D),
    "90d": buildPeriod(
      { ...SYNTH_KPIS_30D, total_jobs: 48, total_jobs_delta: 12, total_activities: 130, total_activities_delta: 28, contacts_linked: 9, notes_count: 41, notes_count_delta: 9 },
      [...SYNTH_JOBS_OVER_TIME_30D, { period: dayAgo(-7), count: 7 }, { period: dayAgo(-14), count: 5 }],
      SYNTH_ACTIVITIES_BY_TYPE_30D
    ),
    "all_time": buildPeriod(
      { ...SYNTH_KPIS_30D, total_jobs: 48, total_jobs_delta: 0, total_activities: 130, total_activities_delta: 0, contacts_linked: 9, notes_count: 41, notes_count_delta: 0 },
      SYNTH_JOBS_OVER_TIME_30D,
      SYNTH_ACTIVITIES_BY_TYPE_30D
    ),
  },
  stale_jobs: SYNTH_STALE_JOBS,
  upcoming_activities: SYNTH_UPCOMING,
};
